import { render, staticRenderFns } from "./CommentComponent.vue?vue&type=template&id=2dc8b3e7&scoped=true&"
import script from "./CommentComponent.vue?vue&type=script&lang=js&"
export * from "./CommentComponent.vue?vue&type=script&lang=js&"
import style0 from "./CommentComponent.vue?vue&type=style&index=0&id=2dc8b3e7&lang=scss&scoped=true&"
import style1 from "./CommentComponent.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc8b3e7",
  null
  
)

/* custom blocks */
import block0 from "./CommentComponent.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports